var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads-statistic"},[_vm._l((_vm.dashboardCards),function(el,idx){return [_c('div',{key:idx,staticClass:"column is-6 is-6-real-mobile is-3-fullhd"},[_c('DashboardCard',{attrs:{"title":el.title,"data":el.data}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }